import { FormattedMessage } from 'react-intl';
import { ReactNode } from 'react';

import { PoolSelect } from '../../select';
import { useFilter } from '../context';

export const NoteToCustomerFilter = () => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (comment?: 'true' | 'false') => {
        filter.delete('hasNoteToCustomer');
        if (comment) {
            filter.set('hasNoteToCustomer', comment);
        }
        updateFilter(filter);
    };

    const getDisplayValue = (commentValue: unknown): ReactNode => {
        if (typeof commentValue !== 'string') {
            return '';
        }

        const comment = commentValue as 'true' | 'false';
        return <FormattedMessage id="app.select.noteToCustomer" values={{ value: comment }} />;
    };

    registerFilterMap('hasNoteToCustomer', getDisplayValue);

    return (
        <PoolSelect
            disallowDefaultValue={true}
            name="hasNoteToCustomer"
            label={<FormattedMessage id="app.filter.hasNoteToCustomerLabel" />}
            fullWidth={true}
            value={filter.get('hasNoteToCustomer')}
            onValueChange={onSelected}
            noSorting={true}
            options={[
                {
                    value: 'true',
                    displayValue: <FormattedMessage id="app.select.noteToCustomer" values={{ value: 'true' }} />,
                },
                {
                    value: 'false',
                    displayValue: <FormattedMessage id="app.select.noteToCustomer" values={{ value: 'false' }} />,
                },
            ]}
        />
    );
};
